export default __webpack_public_path__ + "static/media/pdfIcon6.87027eba.svg";